import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FeedbackDataDispatcher } from './feedback-data.dispatcher';
import { FeedbackDataEffects } from './feedback-data.effects';
import { FEATURE_NAME, reducer } from './feedback-data.reducer';
import { FeedbackDataService } from './feedback-data.service';
import { FeedbackDataStore } from './feedback-data.store';
import { FeedbackDataBuilder } from './feedback-data.builder';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([FeedbackDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
  declarations: [],
})
export class FeedbackDataModule {
  static forRoot(): ModuleWithProviders<FeedbackDataModule> {
    return {
      ngModule: FeedbackDataModule,
      providers: [
        FeedbackDataService,
        FeedbackDataStore,
        FeedbackDataDispatcher,
        FeedbackDataBuilder,
      ],
    };
  }
}
